import React from 'react'

const FaqBlockIcon = () => {
  return (
    <svg viewBox='0 0 48 48' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <g filter='url(#filter0_b_821_8970)'>
        <circle r='24' transform='matrix(1 0 0 -1 24 24)' fill='#3071EE' fillOpacity='0.1' />
        <circle r='23' transform='matrix(1 0 0 -1 24 24)' stroke='#3071EE' strokeWidth='2' />
      </g>
      <path
        d='M25.5 34C25.5 34.8284 24.8284 35.5 24 35.5C23.1716 35.5 22.5 34.8284 22.5 34H25.5ZM22.9393 12.9393C23.5251 12.3536 24.4749 12.3536 25.0607 12.9393L34.6066 22.4853C35.1924 23.0711 35.1924 24.0208 34.6066 24.6066C34.0208 25.1924 33.0711 25.1924 32.4853 24.6066L24 16.1213L15.5147 24.6066C14.9289 25.1924 13.9792 25.1924 13.3934 24.6066C12.8076 24.0208 12.8076 23.0711 13.3934 22.4853L22.9393 12.9393ZM22.5 34V14H25.5V34H22.5Z'
        fill='#3071EE'
      />
      <defs>
        <filter
          id='filter0_b_821_8970'
          x='-40'
          y='-40'
          width='128'
          height='128'
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'>
          <feFlood floodOpacity='0' result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImage' stdDeviation='20' />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_821_8970' />
          <feBlend mode='normal' in='SourceGraphic' in2='effect1_backgroundBlur_821_8970' result='shape' />
        </filter>
      </defs>
    </svg>
  )
}

export default FaqBlockIcon
